import { PromotionPromocode } from '../types/Deals';
import { PromocodeCard } from './PromocodeCard';

type PromoCodesListProps = {
  promoCodes: PromotionPromocode[];
};

export const PromoCodesList = ({ promoCodes }: PromoCodesListProps) => {
  if (!promoCodes.length) {
    return null;
  }

  return (
    <div className="flex flex-col space-y-3 pb-6">
      {promoCodes.map(promo => (
        <PromocodeCard key={promo.id} promo={promo} />
      ))}
    </div>
  );
};
